/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { fetchUtils, DataProvider } from "react-admin";
import { stringify } from "query-string";
import { apiUrl } from "../config";
import { services } from "../services";
import ipfs from "../config/ipfs";

interface HttpClientOptions {
  headers?: Headers;
  method?: string;
  body?: string;
}

interface ApiResponse {
  json: {
    data: any[];
    pagination?: {
      totalRecords: number;
    };
  };
  headers?: Headers;
}

interface ResourceParams {
  pagination: {
    page: number;
    perPage: number;
  };
  sort?: {
    field: string;
    order: string;
  };
  filter: Record<string, any>;
  ids?: string[];
  id?: string;
  target?: string;
  data?: any;
}

interface RentalRecord {
  _id: string;
  assetId?: {
    saleEndDate?: string;
    [key: string]: any;
  };
  [key: string]: any;
}

const httpClient = (
  url: string,
  options: HttpClientOptions = {},
): Promise<ApiResponse> => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" });
  }
  const token = localStorage.getItem("token");
  options.headers.set("x-auth-token", `${token}`);
  return fetchUtils.fetchJson(url, options);
};

const dataProvider: DataProvider = {
  // @ts-ignore
  getList: (resource: string, params: ResourceParams) => {
    let url = "";
    const query: string[] = [];
    query.push(`page=${params.pagination.page}`);
    query.push(`limit=${params.pagination.perPage}`);

    if (resource === "users") {
      Object.keys(params.filter).map((key) =>
        query.push("roleId=" + params.filter[key]),
      );
      url = `${apiUrl}/user/list?${query.join("&")}`;
    } else if (resource === "assetType") {
      url = `${apiUrl}/asset-type`;
    } else if (resource === "assets") {
      url = `${apiUrl}/asset?${query.join("&")}`;
    } else if (resource === "banners") {
      url = `${apiUrl}/admin/banner/listForAdmin`;
    } else if (resource === "profile-info") {
      url = `${apiUrl}/admin/profile-info/listForAdmin`;
    } else if (resource === "info") {
      url = `${apiUrl}/admin/info/listForAdmin`;
    } else if (resource === "hall-frame-info") {
      url = `${apiUrl}/admin/hall-frame-info/listForAdmin`;
    } else if (resource === "collections") {
      url = `${apiUrl}/nft/listCollectionForAdmin?${query.join("&")}`;
    } else if (resource === "popular-nft") {
      url = `${apiUrl}/admin/popular/listForAdmin`;
    } else if (resource === "popular-collection") {
      url = `${apiUrl}/admin/popularCollection/listForAdmin`;
    } else if (resource === "rental") {
      url = `${apiUrl}/rental/getRentalList`;
    }

    return httpClient(url)
      .then((response) => {
        // Log governmentId for users resource
        if (
          resource === "users" &&
          response.json.data &&
          response.json.data.length > 0
        ) {
        }

        const mappedData = response.json.data.map((record: RentalRecord) => {
          if (resource === "rental") {
            const saleEndDateString = record?.assetId?.saleEndDate;
            const saleEndDate = new Date(saleEndDateString || "");

            if (isNaN(saleEndDate.getTime())) {
            }

            const formattedDate = !isNaN(saleEndDate.getTime())
              ? saleEndDate.toLocaleDateString("en-GB")
              : "Invalid Date";

            return {
              ...record,
              ...record.assetId,
              saleEndDate: formattedDate,
              id: record._id,
            };
          } else {
            // For users, ensure governmentId is included
            const mappedRecord = {
              ...record,
              id: record._id,
            };

            // Explicitly include governmentId if it exists
            if (
              resource === "users" &&
              (record as any).governmentId !== undefined
            ) {
              (mappedRecord as any).governmentId = (record as any).governmentId;
            }

            return mappedRecord;
          }
        });

        return {
          data: mappedData,
          total: response.json.data.length,
        };
      })
      .catch((error) => {
        return { data: [], total: 0 };
      });
  },

  // @ts-ignore
  getOne: (resource: string, params: ResourceParams) => {
    let url = "";
    if (resource === "users") {
      url = `${apiUrl}/user/userDetails?userId=${params.id}`;
    } else if (resource === "categories") {
      url = `${apiUrl}/category/categoryDetails?categoryId=${params.id}`;
    } else if (resource === "assets") {
      url = `${apiUrl}/asset/${params.id}`;
    } else if (resource === "banners") {
      url = `${apiUrl}/admin/banner/details/${params.id}`;
    } else if (resource === "profile-info") {
      url = `${apiUrl}/admin/profile-info/details/${params.id}`;
    } else if (resource === "info") {
      url = `${apiUrl}/admin/info/details/${params.id}`;
    } else if (resource === "hall-frame-info") {
      url = `${apiUrl}/admin/hall-frame-info/details/${params.id}`;
    } else if (resource === "collections") {
      url = `${apiUrl}/nft/collection/${params.id}`;
    } else if (resource === "rental") {
      url = `${apiUrl}/rental/property/${params.id}`;
    } else if (resource === "popular-nft") {
      url = `${apiUrl}/admin/popular/listPopularDetails/${params.id}`;
      return httpClient(url).then(({ json }) => ({
        data: json.data[0],
      }));
    } else if (resource === "popular-collection") {
      url = `${apiUrl}/admin/popularCollection/listPopularDetails/${params.id}`;
      return httpClient(url).then(({ json }) => ({
        data: json.data[0],
      }));
    }

    return httpClient(url)
      .then((response) => {
        if (resource === "rental") {
          const mappedData = {
            // @ts-ignore
            ...response.json.data.assetId,
            ...response.json.data,
            // @ts-ignore
            id: response.json.data._id || params.id,
          };
          return {
            data: mappedData,
            total: response.json.data.length,
          };
        } else {
          // Type assertion: getOne always returns a single object, not an array
          const rawData = response.json.data as any;

          // Log governmentId specifically for users resource
          if (resource === "users" && rawData && !Array.isArray(rawData)) {
            // GovernmentId processing for users
          }

          const mappedData = {
            ...rawData,
            // @ts-ignore
            id: rawData._id || params.id,
            // Explicitly ensure governmentId is included for users
            ...(resource === "users" &&
              !Array.isArray(rawData) &&
              rawData.governmentId !== undefined && {
                governmentId: rawData.governmentId,
              }),
          };

          // Log mapped data for users
          if (resource === "users" && !Array.isArray(rawData)) {
          }

          return {
            data: mappedData,
            total: Array.isArray(response.json.data)
              ? response.json.data.length
              : 1,
          };
        }
      })
      .catch((error) => {
        return { data: [], total: 0 };
      });
  },

  // @ts-ignore
  getMany: (resource: string, params: ResourceParams) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;
    return httpClient(url).then(({ json }) => ({ data: json }));
  },

  // @ts-ignore
  getManyReference: (resource: string, params: ResourceParams) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort || { field: "", order: "" };
    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify({
        ...params.filter,
        [params.target || ""]: params.id,
      }),
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;

    return httpClient(url).then(({ headers, json }) => ({
      data: json,
      total: parseInt(
        headers?.get("content-range")?.split("/").pop() || "0",
        10,
      ),
    }));
  },

  // @ts-ignore
  update: (resource: string, params: ResourceParams) => {
    let url = "";
    return httpClient(url, {
      method: "PUT",
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },

  // @ts-ignore
  updateMany: (resource: string, params: ResourceParams) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
      method: "PUT",
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },

  // @ts-ignore
  create: (resource: string, params: ResourceParams) => {
    let url = "";
    if (resource === "nft") {
      url = `${apiUrl}/nft/addNft`;
    }

    return httpClient(url, {
      method: "POST",
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({
      // @ts-ignore
      data: { ...params.data, id: json.id },
    }));
  },

  // @ts-ignore
  delete: async (resource: string, params: ResourceParams) => {
    let url = "";
    if (resource === "banners") {
      url = `${apiUrl}/admin/banner/delete/${params.id}`;
    } else if (resource === "info") {
      url = `${apiUrl}/admin/info/delete/${params.id}`;
    } else if (resource === "hall-frame-info") {
      url = `${apiUrl}/admin/hall-frame-info/delete/${params.id}`;
    } else if (resource === "profile-info") {
      url = `${apiUrl}/admin/profile-info/delete/${params.id}`;
    } else if (resource === "assets") {
      url = `${apiUrl}/asset/delete/${params.id}`;
    } else if (resource === "popular-collection") {
      url = `${apiUrl}/admin/popularCollection/delete/${params.id}`;
    }

    return httpClient(url, {
      method: "DELETE",
    }).then(({ json }) => ({ data: json }));
  },

  // @ts-ignore
  deleteMany: (resource: string, params: ResourceParams) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
      method: "DELETE",
      body: JSON.stringify(params.data),
    }).then(({ json }) => ({ data: json }));
  },
};

export default dataProvider;
